import * as React from 'react';
import { useState } from 'react';
import { Button, ButtonSize, ButtonVariant, Sheet, YStack } from 'smoothie';

import ColorSelection from '../steps/ColorSelection';

interface EditColorSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (color: string) => void;
    icon: string;
    selectedColor: string;
}

const EditColorSheet = ({
    isOpen,
    onClose,
    onSubmit,
    icon,
    selectedColor,
}: EditColorSheetProps) => {
    const [color, setColor] = useState(selectedColor);

    return (
        <Sheet isOpen={isOpen} onClose={onClose} title="Color" showCloseButton>
            <YStack alignItems="center" marginTop={16}>
                {/* This is a workaround: for some reason ColorSelection doesn't render anything below it (might be a quirk with FlatList) */}
                <YStack width="100%" gap={20} flexDirection="column-reverse">
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Save"
                        onPress={() => {
                            onSubmit(color);
                        }}
                    />
                    <ColorSelection
                        icon={icon}
                        selectedColor={color}
                        onSelect={(color) => {
                            setColor(color);
                        }}
                    />
                </YStack>
            </YStack>
        </Sheet>
    );
};

export default EditColorSheet;
